module.exports = __webpack_public_path__ + "img/29_men-or-women.8f1d4e08.jpg";